/*
    Copyright (c) Computer-L.A.N. GmbH (http://www.computer-lan.de).
    Alle Rechte vorbehalten.
*/

import React from "react";
import VerticalSplit from "../../../Basis/Components/VerticalSplit";
import { createBelegeRouterDefinitions } from "../../Belege/Routes/belegeRouterDefinitions";
import { createBelegungenRouterDefinitions } from "../../Ressourcen/Routes/ressourcenRouterDefinitions";
import { createRabattcodesRouterDefinitions } from "../../Seminare/Routes/seminareRouterDefinitions";
import ContextInfo from "../Utils/ContextInfo";
import AppRouterDefinition from "./../../../AppRouterDefinition";
const TeilnahmelistenpositionViewRedirect = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmelistenpositionViewRedirect"));
const TeilnahmelisteViewRedirect = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmelisteViewRedirect"));
const TeilnahmenNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmenNavigationView"));
const TeilnahmeView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmeView"));
const TeilnahmeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/TeilnahmeBreadcrumb"));
const TeilnahmeDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmeDetailsView"));
const TeilnahmeTermineView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmeTermineView"));
const TeilnahmeTermineBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/TeilnahmeTermineBreadcrumb"));
const TeilnahmeAdresseView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmeAdresseView"));
const TeilnahmeAdresseBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/TeilnahmeAdresseBreadcrumb"));
const TeilnahmenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TeilnahmenView"));
const TeilnahmeEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmeEinstellungenDetailsView"));
const EingabefelderView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefelderView"));
const EingabefeldView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefeldView"));
const EingabefeldDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefeldDetailsView"));
const EingabefelderNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefelderNavigationView"));
const EingabefelderBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/EingabefelderBreadcrumb"));
const EingabefeldBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/EingabefeldBreadcrumb"));
const BrandingView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BrandingView"));
const BrandingBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/BrandingBreadcrumb"));
const CheckoutEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Teilnahmen/Views/CheckoutEinstellungenDetailsView"))
const CheckoutBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/CheckoutBreadcrumb"));
const SuchEinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/SuchEinstellungenDetailsView"));
const SuchEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/SuchEinstellungenBreadcrumb"));
const SuchEinstellungenNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/SuchEinstellungenNavigationView"));
const SuchEinstellungView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/SuchEinstellungView"));
const SuchEinstellungDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/SuchEinstellungDetailsView"));
const SuchEinstellungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/SuchEinstellungBreadcrumb"));
const EinstellbareBegriffeView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Teilnahmen/Views/EinstellbareBegriffeView"))
const EinstellbareBegriffeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Teilnahmen/Components/EinstellbareBegriffeBreadcrumb"))
const DrucklayoutDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Belege/Views/DrucklayoutDetailsView"));
const DrucklayoutBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Belege/Components/DrucklayoutBreadcrumb"));
const AushangDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Einstellungen/Views/AushangDetailsView"));
const AushangBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Einstellungen/Components/AushangBreadcrumb"));
const AushangRessourcenDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Einstellungen/Views/AushangRessourcenView"));
const AushangRessourcenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Einstellungen/Components/AushangRessourcenBreadcrumb"));
const BelegeinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Belege/Components/BelegeinstellungenBreadcrumb"));
const BelegeinstellungenDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "../../Belege/Views/BelegeinstellungenDetailsView"));
const TeilnahmenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */ "./../Components/TeilnahmenBreadcrumb"));
const TeilnahmedateienBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/TeilnahmedateienBreadcrumb"));
const TeilnahmedateiBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/TeilnahmedateiBreadcrumb"));
const TeilnahmedateiView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmedateiView"));
const TeilnahmedateienView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmedateienView"));
const TeilnahmedateienNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmedateienNavigationView"));
const TeilnahmedateiDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmedateiDetailsView"));
const TeilnahmeZusatzfelderView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/TeilnahmeZusatzfelderView"));
const EingabefelderDefinitionView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefelderDefinitionView"));
const EingabefelderDefinitionDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefelderDefinitionDetailsView"));
const EingabefelderDefinitionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefelderDefinitionenNavigationView"));
const EingabefelderDefinitionenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/EingabefelderDefinitionenView"));
const EingabefelderDefinitionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/EingabefelderDefinitionBreadcrumb"));
const EingabefelderDefinitionenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/EingabefelderDefinitionenBreadcrumb"));
const BriefanredeEinstellungenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Einstellungen/Views/BriefanredeEinstellungenView"));
const BriefanredeEinstellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../../Einstellungen/Components/BriefanredeEinstellungenBreadcrumb"))
const RabattcodesView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RabattcodesView"));
const RabattcodesNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RabattcodesNavigationView"));
const RabattcodeView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RabattcodeView"));
const RabattcodeDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RabattcodeDetailsView"));
const RabattcodeBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/RabattcodeBreadcrumb"));
const RabattcodesBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/RabattcodesBreadcrumb"));
const RabattcodeEinloesungenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RabattcodeEinloesungenView"));
const RabattcodeEinloesungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/RabattcodeEinloesungenBreadcrumb"));
const BestellpositionenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellpositionenView"));
const BestellpositionAdresseView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BestellpositionAdresseView"));
const BestellpositionRechnungsdatenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BestellpositionRechnungsdatenView"));
const BestellpositionBestellteArtikelView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BestellpositionBestellteArtikelView"));
const BestellpositionBestellteRessourcenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BestellpositionBestellteRessourcenView"));
const BestellpositionView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BestellpositionView"));
const BestellpositionenNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/BestellpositionenNavigationView"));
const BestellpositionBestellteArtikelBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/BestellpositionBestellteArtikelBreadcrumb"));
const BestellpositionBestellteRessourcenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/BestellpositionBestellteRessourcenBreadcrumb"));
const BestellungenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/BestellungenBreadcrumb"));
const BestellpositionBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/BestellpositionBreadcrumb"));
const BestellpositionRechnungsdatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/BestellpositionRechnungsdatenBreadcrumb"));
const RechnungsdatenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RechnungsdatenView"));
const RechnungsdatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/RechnungsdatenBreadcrumb"));
const BestellpositionViewRedirect = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellpositionViewRedirect"));
const BestellteArtikelBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/BestellteArtikelBreadcrumb"));
const BestellterArtikelBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/BestellterArtikelBreadcrumb"));
const BestellteArtikelView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellteArtikelView"));
const BestellteArtikelNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellteArtikelNavigationView"));
const BestellterArtikelView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellterArtikelView"));
const BestellterArtikelDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellterArtikelDetailsView"));
const BestellterArtikelRechnungsdatenView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/BestellterArtikelRechnungsdatenView"));
const BestellterArtikelRechnungsdatenBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Components/BestellterArtikelRechnungsdatenBreadcrumb"));
const TeilnahmeZertifikatBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Components/TeilnahmeZertifikatBreadcrumb"));
const TeilnahmeZertifikateBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Components/TeilnahmeZertifikateBreadcrumb"));
const TeilnahmeZertifikateView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Views/TeilnahmeZertifikateView"));
const TeilnahmeZertifikateNavigationView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Views/TeilnahmeZertifikateNavigationView"));
const TeilnahmeZertifikatView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Views/TeilnahmeZertifikatView"));
const TeilnahmeZertifikatDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Views/TeilnahmeZertifikatDetailsView"));
const TeilnahmeZertifikatViewRedirect = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Dokumente" */"./../../Dokumente/Views/TeilnahmeZertifikatViewRedirect"));
const TicketscannerView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/TicketscannerView"));
const RegelView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"./../Views/RegelView"));
const VerpflegungBreadcrumb = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Components/VerpflegungBreadcrumb"));
const VerpflegungDetailsView = React.lazy(() => import(/* webpackChunkName: "Teilnahmen_Teilnahmen" */"../Views/VerpflegungDetailsView"));

const RABATTCODESPATH = "/rabattcodes";
const RABATTCODEPATH = "/rabattcode/:rabattcodeId";
export const BRANDINGPATH = "/branding";
const TEILNAHMEPATH = "/teilnahme/:teilnahmeId";
const EINGABEFELDERDEFINITIONPATH = BRANDINGPATH + "/eingabefelderDefinition/:eingabefelderDefinitionId";
const EINGABEFELDERPATH = EINGABEFELDERDEFINITIONPATH + "/eingabefelder";
const EINGABEFELDPATH = EINGABEFELDERDEFINITIONPATH + "/eingabefeld/:eingabefeldId";
const BELEGEINSTELLUNGENPATH = BRANDINGPATH + "/belegeinstellungen/:belegeinstellungenId";
const BRIEFANREDEEINSTELLUNGENPATH = BRANDINGPATH + "/briefanredeEinstellungen";
const BESTELLUNGENPATH = "/bestellungen";
const BESTELLTEARTIKELPATH = "/bestellteartikel";
const BESTELLTERARTIKELPATH = "/bestellterartikel/:bestellterArtikelId";

export function createBestellpositionRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            path: safePathPrefix + "/bestellposition/:bestellpositionId",
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <BestellpositionView {...renderProps} />}
                    left={() => <BestellpositionenNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellpositionBreadcrumb {...createProps} />
            ],
        },
        {
            exact: true,
            path: safePathPrefix + "/bestellposition/:bestellpositionId",
            parentPath: safePathPrefix + "/bestellposition/:bestellpositionId",
            render: (renderProps: any) => (
                <BestellpositionAdresseView {...renderProps} />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellpositionBreadcrumb {...createProps} />
            ],
        },
        {
            exact: true,
            path: safePathPrefix + "/bestellposition/:bestellpositionId/rechnungsdaten",
            parentPath: safePathPrefix + "/bestellposition/:bestellpositionId",
            render: (renderProps: any) => (
                <BestellpositionRechnungsdatenView {...renderProps} />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellpositionBreadcrumb {...createProps} />,
                <BestellpositionRechnungsdatenBreadcrumb { ...createProps } />
            ]
        },
        {
            path: safePathPrefix + "/bestellposition/:bestellpositionId/bestellteArtikel",
            parentPath: safePathPrefix + "/bestellposition/:bestellpositionId",
            render: (renderProps: any) => (
                <BestellpositionBestellteArtikelView {...renderProps} />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellpositionBreadcrumb {...createProps} />,
                <BestellpositionBestellteArtikelBreadcrumb {...createProps} />
            ],
        },
        {
            path: safePathPrefix + "/bestellposition/:bestellpositionId/bestellteRessourcen",
            parentPath: safePathPrefix + "/bestellposition/:bestellpositionId",
            render: (renderProps: any) => (
                <BestellpositionBestellteRessourcenView {...renderProps} />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellpositionBreadcrumb {...createProps} />,
                <BestellpositionBestellteRessourcenBreadcrumb {...createProps} />
            ],
        }
    ];
}

export function createTeilnahmenRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>,
    createContextInfos?: (createProps: any) => ContextInfo[]): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/termine`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <TeilnahmeTermineView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmeTermineBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />
            ],
        },
        ...createBelegeRouterDefinitions(safePathPrefix + TEILNAHMEPATH, (createProps) => [
            ...createPreBreadcrumbs(createProps),
            <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
            <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
        ]),
        {
            path: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <TeilnahmeView {...renderProps} />}
                    left={() => <TeilnahmenNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + TEILNAHMEPATH,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <TeilnahmeDetailsView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/rechnungsdaten`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <RechnungsdatenView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <RechnungsdatenBreadcrumb teilnahmeId={createProps.teilnahmeId} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/adresse`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <TeilnahmeAdresseView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmeAdresseBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ],
        },
        {
            path: safePathPrefix + `${TEILNAHMEPATH}/datei/:teilnahmedateiId`,
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <TeilnahmedateiView {...renderProps} />}
                    left={() => <TeilnahmedateienNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmedateienBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmedateiBreadcrumb
                    contextInfos={createContextInfos?.(createProps)}
                    teilnahmeId={createProps.teilnahmeId}
                    teilnahmedateiId={createProps.teilnahmedateiId}
                />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/datei/:teilnahmedateiId`,
            parentPath: safePathPrefix + `${TEILNAHMEPATH}/datei/:teilnahmedateiId`,
            render: (renderProps: any) => <TeilnahmedateiDetailsView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmedateienBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmedateiBreadcrumb
                    contextInfos={createContextInfos?.(createProps)}
                    teilnahmeId={createProps.teilnahmeId}
                    teilnahmedateiId={createProps.teilnahmedateiId}
                />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/dateien`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <TeilnahmedateienView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmedateienBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ],
        },
        {
            path: safePathPrefix + `${TEILNAHMEPATH}/teilnahmezertifikat/:teilnahmeZertifikatId`,
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <TeilnahmeZertifikatView {...renderProps} />}
                    left={() => <TeilnahmeZertifikateNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmeZertifikateBreadcrumb {...createProps} />,
                <TeilnahmeZertifikatBreadcrumb {...createProps} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/teilnahmezertifikat/:teilnahmeZertifikatId`,
            parentPath: safePathPrefix + `${TEILNAHMEPATH}/teilnahmezertifikat/:teilnahmeZertifikatId`,
            render: (renderProps: any) => <TeilnahmeZertifikatDetailsView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmeZertifikateBreadcrumb {...createProps} />,
                <TeilnahmeZertifikatBreadcrumb {...createProps} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/teilnahmezertifikate`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <TeilnahmeZertifikateView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmeZertifikateBreadcrumb {...createProps} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + "/teilnahmen",
            parentPath: pathPrefix,
            render: (renderProps: any) => <TeilnahmenView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${TEILNAHMEPATH}/zusatzfelder`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: (renderProps: any) => <TeilnahmeZusatzfelderView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
                <TeilnahmedateienBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ],
        },
        {
            path: safePathPrefix + `${TEILNAHMEPATH}/verpflegung`,
            parentPath: safePathPrefix + TEILNAHMEPATH,
            render: props => <VerpflegungDetailsView {...props} />,
            createBreadcrumbs: props => [
                ...createPreBreadcrumbs(props),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(props)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(props)} teilnahmeId={props.teilnahmeId} />,
                <VerpflegungBreadcrumb {...props} pathPrefix={TEILNAHMEPATH} />,
            ]
        },
        ...createBestellterArtikelRouterDefinitions(
            safePathPrefix + TEILNAHMEPATH,
            (createProps) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ]),
        ...createBelegungenRouterDefinitions(
            safePathPrefix + TEILNAHMEPATH,
            (createProps) => [
                ...createPreBreadcrumbs(createProps),
                <TeilnahmenBreadcrumb contextInfos={createContextInfos?.(createProps)} />,
                <TeilnahmeBreadcrumb contextInfos={createContextInfos?.(createProps)} teilnahmeId={createProps.teilnahmeId} />,
            ]),
    ];
}

export function createBestellterArtikelRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            exact: pathPrefix ? true : undefined,
            parentPath: pathPrefix ? safePathPrefix : undefined,
            path: safePathPrefix + BESTELLTEARTIKELPATH,
            render: (renderProps: any) => <BestellteArtikelView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellteArtikelBreadcrumb seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />],
        },
        {
            path: safePathPrefix + BESTELLTERARTIKELPATH,
            render: (renderProps: any) => (
                <VerticalSplit
                    right={() => <BestellterArtikelView {...renderProps} />}
                    left={() => <BestellteArtikelNavigationView {...renderProps} />}
                />
            ),
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellteArtikelBreadcrumb seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
                <BestellterArtikelBreadcrumb bestellterArtikelId={createProps.bestellterArtikelId} seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + BESTELLTERARTIKELPATH,
            parentPath: safePathPrefix + BESTELLTERARTIKELPATH,
            render: (renderProps: any) => <BestellterArtikelDetailsView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellteArtikelBreadcrumb seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
                <BestellterArtikelBreadcrumb bestellterArtikelId={createProps.bestellterArtikelId} seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
            ],
        },
        {
            exact: true,
            path: safePathPrefix + `${BESTELLTERARTIKELPATH}/rechnungsdaten`,
            parentPath: safePathPrefix + BESTELLTERARTIKELPATH,
            render: (renderProps: any) => <BestellterArtikelRechnungsdatenView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellteArtikelBreadcrumb seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
                <BestellterArtikelBreadcrumb bestellterArtikelId={createProps.bestellterArtikelId} seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
                <BestellterArtikelRechnungsdatenBreadcrumb bestellterArtikelId={createProps.bestellterArtikelId} seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
            ],
        },
        ...createBelegeRouterDefinitions(
            safePathPrefix + BESTELLTERARTIKELPATH,
            (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellteArtikelBreadcrumb seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
                <BestellterArtikelBreadcrumb bestellterArtikelId={createProps.bestellterArtikelId} seminarId={createProps.seminarId} teilnahmeId={createProps.teilnahmeId} adresseId={createProps.adresseId} seminarreiheId={createProps.seminarreiheId} />,
            ],
        )
    ];
}

export function createBestellungenRouterDefinitions(
    pathPrefix: string | undefined,
    createPreBreadcrumbs: (createProps: any) => Array<JSX.Element>): Array<AppRouterDefinition> {
    let safePathPrefix = pathPrefix ?? "";

    return [
        {
            path: safePathPrefix + BESTELLUNGENPATH,
            exact: pathPrefix ? true : undefined,
            parentPath: pathPrefix ? safePathPrefix : undefined,
            render: (renderProps) => <BestellpositionenView {...renderProps} />,
            createBreadcrumbs: (createProps: any) => [
                ...createPreBreadcrumbs(createProps),
                <BestellungenBreadcrumb {...createProps} />
            ],
        },
        ...createBestellpositionRouterDefinitions(
            pathPrefix ? `${pathPrefix}/bestellungen` : "/bestellungen",
            (createProps) => [
                ...createPreBreadcrumbs(createProps),
                <BestellungenBreadcrumb {...createProps} />,
            ])
    ];
}

export const teilnahmenRouterDefinitions: Array<AppRouterDefinition> = [
    {
        exact: true,
        path: BRANDINGPATH,
        parentPath: BRANDINGPATH,
        render: (renderProps: any) => <TeilnahmeEinstellungenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/checkoutEinstellungen`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <CheckoutEinstellungenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <CheckoutBreadcrumb />
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/suchen`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <SuchEinstellungenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <SuchEinstellungenBreadcrumb />
        ],
    },
    {
        path: `${BRANDINGPATH}/suche/:suchEinstellungId`,
        render: (renderProps) => (
            <VerticalSplit
                left={() => <SuchEinstellungenNavigationView {...renderProps} />}
                right={() => <SuchEinstellungView {...renderProps} />}
            />
        ),
        createBreadcrumbs: (props) => [
            <BrandingBreadcrumb />,
            <SuchEinstellungenBreadcrumb />,
            <SuchEinstellungBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/suche/:suchEinstellungId`,
        parentPath: `${BRANDINGPATH}/suche/:suchEinstellungId`,
        render: (renderProps) => <SuchEinstellungDetailsView {...renderProps} />,
        createBreadcrumbs: (props) => [
            <BrandingBreadcrumb />,
            <SuchEinstellungenBreadcrumb />,
            <SuchEinstellungBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/einstellbareBegriffe`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <EinstellbareBegriffeView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <EinstellbareBegriffeBreadcrumb />
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/eingabefelderDefinitionen`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <EingabefelderDefinitionenView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <EingabefelderDefinitionenBreadcrumb />
        ],
    },
    {
        path: EINGABEFELDERDEFINITIONPATH,
        render: (renderProps) => <VerticalSplit
            left={() => <EingabefelderDefinitionenNavigationView {...renderProps} />}
            right={() => <EingabefelderDefinitionView {...renderProps} />}
        />,
        createBreadcrumbs: (createProps) => [
            <BrandingBreadcrumb />,
            <EingabefelderDefinitionenBreadcrumb />,
            <EingabefelderDefinitionBreadcrumb eingabefelderDefinitionId={createProps.eingabefelderDefinitionId} />
        ],
    },
    {
        exact: true,
        path: EINGABEFELDERDEFINITIONPATH,
        parentPath: EINGABEFELDERDEFINITIONPATH,
        render: (renderProps: any) => <EingabefelderDefinitionDetailsView {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: EINGABEFELDPATH,
        render: (renderProps: any) => (
            <VerticalSplit
                right={() => <EingabefeldView {...renderProps} />}
                left={() => <EingabefelderNavigationView {...renderProps} />}
            />),
        createBreadcrumbs: (createProps: any) => [
            <BrandingBreadcrumb />,
            <EingabefelderDefinitionenBreadcrumb />,
            <EingabefelderDefinitionBreadcrumb eingabefelderDefinitionId={createProps.eingabefelderDefinitionId} />,
            <EingabefelderBreadcrumb eingabefelderDefinitionId={createProps.eingabefelderDefinitionId} />,
            <EingabefeldBreadcrumb eingabefelderDefinitionId={createProps.eingabefelderDefinitionId} eingabefeldId={createProps.eingabefeldId} />,
        ],
    },
    {
        exact: true,
        path: EINGABEFELDPATH,
        parentPath: EINGABEFELDPATH,
        render: (renderProps: any) => <EingabefeldDetailsView {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: EINGABEFELDERPATH,
        parentPath: EINGABEFELDERDEFINITIONPATH,
        render: (renderProps: any) => <EingabefelderView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <BrandingBreadcrumb />,
            <EingabefelderDefinitionenBreadcrumb />,
            <EingabefelderDefinitionBreadcrumb eingabefelderDefinitionId={createProps.eingabefelderDefinitionId} />,
            <EingabefelderBreadcrumb eingabefelderDefinitionId={createProps.eingabefelderDefinitionId} />,
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/drucklayout`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <DrucklayoutDetailsView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <DrucklayoutBreadcrumb />
        ],
    },
    {
        exact: true,
        path: BELEGEINSTELLUNGENPATH,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <BelegeinstellungenDetailsView {...renderProps} />,
        createBreadcrumbs: (createProps) => [
            <BrandingBreadcrumb />,
            <BelegeinstellungenBreadcrumb belegeinstellungenId={createProps.belegeinstellungenId} />,
        ],
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/aushang`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <AushangDetailsView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <AushangBreadcrumb />
        ]
    },
    {
        exact: true,
        path: `${BRANDINGPATH}/ressourcen`,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <AushangRessourcenDetailsView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <AushangRessourcenBreadcrumb />
        ]
    },
    {
        path: BRANDINGPATH,
        render: (renderProps: any) => <BrandingView {...renderProps} />,
        createBreadcrumbs: (createProps: any) => [
            <BrandingBreadcrumb />,
        ],
    },
    {
        path: "/teilnahmelistenposition/:teilnahmelistenpositionId",
        render: (renderProps: any) => <TeilnahmelistenpositionViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: "/teilnahmeliste/:teilnahmelisteId",
        render: (renderProps: any) => <TeilnahmelisteViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: "/bestellposition/:bestellpositionId",
        render: (renderProps: any) => <BestellpositionViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        path: "/teilnahmeZertifikat/:teilnahmeZertifikatId",
        render: (renderProps: any) => <TeilnahmeZertifikatViewRedirect {...renderProps} />,
        createBreadcrumbs: () => [],
    },
    {
        exact: true,
        path: BRIEFANREDEEINSTELLUNGENPATH,
        parentPath: BRANDINGPATH,
        render: (renderProps) => <BriefanredeEinstellungenView {...renderProps} />,
        createBreadcrumbs: () => [
            <BrandingBreadcrumb />,
            <BriefanredeEinstellungenBreadcrumb />
        ],
    },
    {
        exact: true,
        path: RABATTCODESPATH,
        render: (renderProps) => <RabattcodesView {...renderProps} />,
        createBreadcrumbs: () => [
            <RabattcodesBreadcrumb />,
        ],
    },
    ...createRabattcodesRouterDefinitions(
        "",
        (props) => [],
    ),
    {
        path: RABATTCODEPATH,
        render: props =>
            <VerticalSplit
                right={() => <RabattcodeView {...props} />}
                left={() => <RabattcodesNavigationView {...props} />}
            />,
        createBreadcrumbs: props => [
            <RabattcodesBreadcrumb />,
            <RabattcodeBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: RABATTCODEPATH,
        path: RABATTCODEPATH,
        render: props => <RabattcodeDetailsView {...props} />,
        createBreadcrumbs: props => [
            <RabattcodesBreadcrumb />,
            <RabattcodeBreadcrumb {...props} />,
        ],
    },
    {
        exact: true,
        parentPath: RABATTCODEPATH,
        path: `${RABATTCODEPATH}/einloesungen`,
        render: props => <RabattcodeEinloesungenView {...props} />,
        createBreadcrumbs: props => [
            <RabattcodesBreadcrumb />,
            <RabattcodeBreadcrumb {...props} />,
            <RabattcodeEinloesungenBreadcrumb {...props} />,
        ],
    },
    {
        path: "/ticketscanner",
        render: props => <TicketscannerView {...props} />,
        createBreadcrumbs: props => [],
    },
    {
        exact: true,
        path: "/regel/:regelId",
        render: props => <RegelView {...props} />,
        createBreadcrumbs: _ => [],
    },

    ...createTeilnahmenRouterDefinitions(undefined, (c) => []),
    ...createBestellungenRouterDefinitions(undefined, (c) => []),
    ...createBestellpositionRouterDefinitions(
        "/teilnahme",
        (createProps: any) => [
            <TeilnahmenBreadcrumb />,
        ]),
    ...createBestellterArtikelRouterDefinitions(undefined, () => [])
];